<template>
  <div class="fullHeight">
    <MypageSideMenu :memberDropClose="true"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-reserve mypage-title-icon"
      >
        <div class="col-sm-12">
            <div class="my-2">
                <div class="row row-notMx justify-content-between">
                    <div class="receipt-title">領収書</div>
                    <div class="text-right">
                      <span class="receipt-no">No.&nbsp;{{ receipt.receipt_no }}</span><br>
                      <span>発行日&nbsp;{{ receipt.receipt_date }}</span>
                    </div>
                </div>
                <div class="row row-notMx receipt-name-row">
                    <div class="receipt-name text-center">{{ receiptAddressee }}</div>
                    <div class="receipt-name-label text-right">様</div>
                </div>
                <div class="row row-notMx">
                    <div class="receipt-price-border text-center">
                      <div class="receipt-price mx-auto">{{ receipt.receipt_amount }}</div>
                    </div>
                    <div class="payTable">
                        <div v-for="pay in receiptPays" :key="pay.payment_no" class="receipt-pays">
                          <span>{{ pay.payment_type }}</span>
                          <span class="float-right">{{ pay.payment_amount }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 row row-notMx mb-3">
          <div class="sp-view-wid575 col-12">
            <table class="reserveDate">
              <tbody>
                <tr class="receipt-data">
                  <td class="taxTableTd text-center width-50">
                    <small>ご利用日</small>
                  </td>
                  <td class="taxTableTd text-center width-50">
                    <small>{{ receipt.reserve_date }}</small>
                  </td>
                </tr>
                <tr class="receipt-data">
                  <td class="taxTableTd text-center width-50">
                    <small>照会番号</small>
                  </td>
                  <td class="taxTableTd text-center width-50">
                    <small>{{ receipt.holder_no }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <span class="tb-area w-100 row row-notMx">
          <div class="col-sm-6 col-12">
            <table class="taxTable">
              <tbody>
                <tr v-for="tax in receiptTaxs" :key="tax.tax_no">
                  <td class="taxTableTd text-center width-50">
                    <small>{{ tax.tax_name }}</small>
                  </td>
                  <td class="taxTableTd text-right width-50">
                    <small>￥{{ tax.tax_amount }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-2 proviso-str">
              <div class="proviso-str-text">{{ receipt.proviso_str ? receipt.proviso_str : '' }}<br>
              上記、正に領収いたしました。</div>
            </div>
          </div>
          <div class="col-sm-6 text-right tax-tdaria">
            <div class="pcview-wid575">
              <table class="reserveDate">
                <tbody>
                  <tr class="receipt-data">
                    <td class="taxTableTd text-center">
                      <span>ご利用日</span>
                    </td>
                    <td class="taxTableTd text-center">
                      <span>{{ receipt.reserve_date }}</span>
                    </td>
                  </tr>
                  <tr class="receipt-data">
                    <td class="taxTableTd text-center">
                      <span>照会番号</span>
                    </td>
                    <td class="taxTableTd text-center">
                      <span>{{ receipt.holder_no }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="company-printing">
              <div class="receipt-company text-left">
                <div class="receipt-company-name">
                  {{ receipt.company_name }}<br>
                  {{ receipt.golf_name }}
                </div>
                <div>
                  〒{{ zipCodeFormat(receipt.zip_code) }}<br>
                  {{ receipt.address }}<br>
                  TEL:{{ receipt.telephone }}&nbsp;<span v-if="receipt.fax">FAX:{{ receipt.fax }}</span>
                </div>
              </div>
            </div>
          </div>
        </span>
        <!-- 印刷ボタン追加 -->
        <template v-slot:listBackBtn>
            <div class="row row-notMx justify-content-center py-3">
                <button
                    type="button"
                    class="bluebackbutton col-sm-3 mx-3 mb-2"
                    @click="ReceiptAddressee">
                宛名変更</button>
                <button
                    type="button"
                    class="bluebackbutton col-sm-3 mx-3 mb-2"
                    :disabled="printDisabled"
                    @click="PrintReceipt">
                PDFを送信</button>
            </div>
            <div class="row row-notMx justify-content-center pb-3">
                <button
                    class="mypagebackbutton col-sm-3 mx-3"
                    @click="BackResultList">
                一覧へ戻る</button>
            </div>
        </template>
    </Card>
    <MypageMenuFooter/>
    <ConfirmDialog
        v-if="dialog === true"
        :initialMessage="registMessage"
        doing=""
        notDoing="閉じる"
        :processing="processing"
        @closeBtn="addoverlayHidden"
      />
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import ConfirmDialog from '../components/ConfirmDialog';
import axios from 'axios';
import { GET_RECEIPT, PRINT_RECEIPT } from '../../constants/receipts';
import { GET_SETTING_VALUE } from '../../constants/system_master';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        ConfirmDialog,
        Card
    },
    data () {
        return {
            // 前ページから受け取る
            settleNo: 1,
            receiptAddressee: '',
            play_date: '',
            member_no: '',
            page_title: '領収書',
            printDisabled: true,
            // 処理の結果のオブジェクト
            processing: {
                result: '',
                resultText: '',
                btnDisabled: 0,
            },
            // 領収書情報
            receipt: {},
            // 領収金額税情報
            receiptTaxs: [],
            // 領収金額情報
            receiptPays: [],
            // 確認ダイアログの表示フラグ
            dialog: false,
            registMessage: this.$t("message.printReceipt")
         };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 日付の表示を修正
         * ---------------------------------------------- */
        dateFormated (data) {
            const date = data.split('-');
            return date[0] + '年' + date[1] + '月' + date[2] + '日';
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.member_no = this.$store.state.auth.loginMember.member_no;
            if (sessionStorage.getItem('MyPage.settleNo')) {
                this.settleNo = sessionStorage.getItem('MyPage.settleNo');
            } else {
                this.settleNo = '0';
            }
            if (sessionStorage.getItem('MyPage.addressee')) {
                this.receiptAddressee = sessionStorage.getItem('MyPage.addressee');
            } else {
                this.receiptAddressee = '';
            }
            // console.log(this.$store.state.auth);
            this.getSettlesDetails();
        },
        /** ----------------------------------------------
         * 精算情報を取得
         * ---------------------------------------------- */
        getSettlesDetails () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: GET_RECEIPT,
                fetchPolicy: 'no-cache',
                variables: {
                    settle_no: this.settleNo
                }
            }).then(res => {
                this.receiptTaxs = [];
                this.receiptPays = [];
                this.receipt = res.data.GetReceipt.Receipt;
                this.receipt.address = this.receipt.prefecture_name + this.receipt.municipality_name + this.receipt.local_name + this.receipt.building_name;
                this.receiptTaxs = res.data.GetReceipt.ReceiptTaxs;
                this.receiptPays = res.data.GetReceipt.ReceiptPays;
                this.getPrintMax(this.receipt.receipts_prints);
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
                this.$store.commit("loading/setIsLoading", false);
            })
        },
        /** --------------------------------------------
         * ハイフン無しの郵便番号を012-3456形式に変換する
         * @param zipCode 対象の郵便番号
         * -------------------------------------------- */
        zipCodeFormat: function (zipCpde) {
            if (zipCpde) {
                var before = zipCpde.substring( 0, 3 );
                var after = zipCpde.substring( 3, 7 );
                return before + '-' + after;
            } else {
                return ' ';
            }
        },
        /** ----------------------------------------------
         * 領収書印刷最大回数取得
         * ---------------------------------------------- */
        getPrintMax: function (printCnt){
            this.$apollo.query({
                query: GET_SETTING_VALUE,
                fetchPolicy: 'no-cache',
                variables: {
                    settingGroup: 'receipts_print_max',
                    settingKey: 'receipts_print_max'
                }
            }).then(res => {
                if (printCnt < res.data.GetSettingValue.setting_value) {
                    this.printDisabled = false;
                }
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$set(this.processing, 'resultText', error);
                this.$store.commit("loading/setIsLoading", false);
            })
        },

        /** ----------------------------------------------
         * 印刷
         * ---------------------------------------------- */
        PrintReceipt: function (){
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.query({
                query: PRINT_RECEIPT,
                fetchPolicy: 'no-cache',
                variables: {
                    settle_no: this.settleNo,
                    processing_kbn: 1, // PDF作成
                    receipt_addressee: this.receiptAddressee
                }
            }).then(res => {
                if (res.data.PrintReceipt.result == 0) {
                    this.DownloadFile();
                    // 「領収書を作成しました。」
                    // this.$set(this.processing, 'resultText', this.$t("message.printReceipt"));
                    this.$set(this.processing, 'resultText', "ご登録のメールアドレスに送信しました。");
                } else {
                    this.$set(this.processing, 'resultText', this.$t("error.print.receiptNg"));
                }
                this.$set(this.processing, 'result', 1);
                this.$set(this.processing, 'btnDisabled', 0);
                this.dialog = true;
                this.$store.commit("loading/setIsLoading", false);
            }).catch(error => {
                this.$set(this.processing, 'result', 1);
                this.$set(this.processing, 'btnDisabled', 0);
                this.$set(this.processing, 'resultText', error);
                this.dialog = true;
                this.$store.commit("loading/setIsLoading", false);
            })
        },
        /** ----------------------------------------------
         * PDFダウンロード処理
         * ---------------------------------------------- */
        DownloadFile: async function () {
            try {
                // const fileName = {
                //     'fileName': '領収書_' + this.settleNo + '.pdf'
                // };
                // let response = await axios.post('/api/download', fileName, {responseType: 'arraybuffer'});
                // var blob = new Blob([response.data], {type: 'application/pdf'});
                // const link = document.createElement('a');
                // link.href = window.URL.createObjectURL(blob);
                // link.setAttribute('download', '領収書.pdf');
                // link.download = fileName['fileName'];
                // link.click();
                // ダウンロード後PDFを削除
                this.DeletePdf();
            } catch (error) {
                this.$set(this.processing, 'result', 1);
                this.$set(this.processing, 'btnDisabled', 0);
                this.$set(this.processing, 'resultText', error);
                this.dialog = true;
            }

        },
        /** ----------------------------------------------
         * PDFファイル削除処理
         * ---------------------------------------------- */
        DeletePdf: async function () {
            this.$apollo.query({
                query: PRINT_RECEIPT,
                fetchPolicy: 'no-cache',
                variables: {
                    settle_no: this.settleNo,
                    processing_kbn: 2
                }
            }).then(res => {

            }).catch(error => {
                console.log(error);
            })
        },

        /** ----------------------------------------------
         * 確認ダイアログを閉じる
         * ---------------------------------------------- */
        addoverlayHidden () {
            this.$set(this.processing, 'result', '');
            this.dialog = false;
        },
        /** ----------------------------------------------
         * 宛名変更
         * ---------------------------------------------- */
        ReceiptAddressee: function (){
            this.$router.push({ path: '/mypage-input-addressee' });
        },
        /** ----------------------------------------------
         * 実績一覧へ戻る
         * ---------------------------------------------- */
        BackResultList: function (){
            this.$router.push({ path: '/mypage-result-list' });
        }
    },

    computed: {
    }
}
</script>

<style scoped>
.receipt-title {
    font-size: 1.8rem;
    font-weight: bold;
    margin-left: 3%;
    margin-bottom: 15px;
}
.receipt-name-label {
    margin-bottom: 15px;
    font-size: 1.5rem;
    width: 3%;
    border-bottom: 1px solid #212529;
}
.receipt-name {
    margin-left: 3%;
    margin-bottom: 15px;
    font-size: 1.5rem;
    width: 60%;
    border-bottom: 1px solid #212529;
}
.receipt-name-row {
    align-items: flex-end;
}
.receipt-data{
    height: 1.5rem;
}
.receipt-price-border {
    font-size: 1.5rem;
    width: 70%;
}
.receipt-price {
    border-bottom: 2px solid #212529;
    width: 70%;
}
.receipt-price-label {
    font-size: x-large;
    width: 25%;
}
.tb-area{
    min-height: 200px;
}
.receipt-company {
    margin:auto;
    width: 70%;
    max-width: 100%;
    font-size: 0.8rem;
}
.receipt-company-name {
    font-weight: bold;
}
.mgr-10{
    margin-right : 10px;
}
.items-title{
    margin-left : 200px;
}
.tax-tdaria {
    display: flex;
    flex-direction: column;
}
.items-value{
    margin-right : 50px;
}
.flex {
    display: flex;
}
.taxTable {
    max-width: 100%;
    width: 75%;
    margin-left: 10%;
    padding: 0.5rem;
}
.taxTableTd {
    border: 1px solid;
}
.payTable {
    width: 30%;
    padding: 0rem;
    font-size: 0.7rem;
    margin-left : auto ;
	margin-right : 0 ;
}
.company-printing {
    margin-top: auto;
}
.proviso-str {
    font-size: 0.9rem;
    padding-left: 20%;
}
.reserveDate {
    width: 70%;
    padding: 0rem;
    margin-right: auto;
    margin-left: auto;
    border: 1px solid;
}
.proviso-str-text{
    width: 100%;
}
.receipt-no {
    border-bottom: black solid 1px;
}
.width-40 {
    width: 40%;
}
.width-50 {
    width: 50%;
}
.width-60 {
    width: 60%;
}
@media (max-width: 575px) {
    .receipt-title {
        font-size: 1.5rem;
    }
    .receipt-name {
        width: 90%;
    }
    .receipt-name-label {
        width: 7%;
    }
    .taxTable {
        width: 100%;
        margin-left: 0%;
    }
    .receipt-price-border {
        width: 55%;
    }
    .payTable {
        width: 45%;
        font-size: 0.7rem;
    }
    .reserveDate {
        width: 100%;
    }
    .receipt-company {
        width: auto;
        margin-left: auto;
        display: inline-block;
    }
    .company-printing {
        margin-top: 20px;
    }
}

@media (max-width: 370px) {
    .receipt-price-border {
        font-size: 1.5rem;
        width: 100%;
    }
    .payTable {
        margin-top: 0.5rem;
        width: 100%;
        font-size: 0.7rem;
    }
}
</style>
